import Hero from "../components/Hero";
import Menu from "../components/Menu";
import Testimonials from "../components/Testimonials";
import Description from "../components/Description";
const Homepage = () => {
  return (
    <main>
      <Hero />
      <Menu />
      <Testimonials />
      <Description />
    </main>
  );
};

export default Homepage;
